import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../environments/environment';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  form: FormGroup;
  redirectData;
  showPassword = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private toastr: ToastrService,
  ) {
    this.redirectData = this.router.getCurrentNavigation().extras.state;
  }

  ngOnInit(): void {
    if (this.authService.user$.getValue()) {
      this.router.navigate(['dashboard']);
    }
    this.initForm();
  }

  initForm() {
    const config = {
      name: [null, Validators.required],
      password: [null, Validators.required],
    };
    this.form = this.fb.group(config);
  }

  get fcName(): AbstractControl {
    return this.form.controls.name;
  }

  get fcPassword(): AbstractControl {
    return this.form.controls.password;
  }

  onSubmit() {
    this.authService.login(
      this.fcName.value,
      this.fcPassword.value,
      ).subscribe(() => {
      const url = this.route.snapshot.queryParamMap.get('returnUrl') || 'dashboard';
      this.router.navigate([url]);
    }, err => {
      this.toastr.error(err.error.detail);
    });
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  resetPassword() {
    window.open(environment.passwordReset, '_blank').focus();
  }
}
